import React, { useEffect, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import {
  query,
  collection,
  orderBy,
  getDocs,
  addDoc,
  Timestamp,
  where,
  doc,
  updateDoc,
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import Dateformat from "helper/constant/timeFormat";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import "./index.css";

function TeachersAttendance() {
  const [teacherList, setTeacherList] = useState([]);
  const [calendardate, setCalendarDate] = useState(null);
  const [previousAttendance, setPreviousAttendance] = useState(null);
   const [loading, setLoading] = useState(false)
  const today = moment(new Date()).format(Dateformat.DDMMYYYY);

  // MARK: use Effect 
  useEffect(() => {
    setCalendarDate(new Date());
    previousAttendanceData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // MARK: date click function
  const clickOnDate = (e) => {
    const newDate = moment(e.value).format(Dateformat.YYYYMMDD);
    setCalendarDate(e.value);
    previousAttendanceData(newDate);
  };

  // MARK: attendance input
  const clickOnCheckBox = (selectedTeacher) => () => {
    setTeacherList((prevList) =>
      prevList.map((teacher) =>
        teacher.id === selectedTeacher.id
          ? { ...teacher, isChecked: !teacher.isChecked }
          : teacher
      )
    );
  };
  
    //  payload 
    function payload() {
      const createdAt = Timestamp.fromDate(new Date()).toMillis();
      const object = {
        created_at: createdAt,
        date_value: moment(calendardate).format(Dateformat.YYYYMMDD),
      };
  
      var teacherIDs = [];
  
      teacherList.forEach((element) => {
        if (element.isChecked) {
          teacherIDs.push(element.id);
        }
      });
      const dateOnly = moment(object.date_value, Dateformat.YYYYMMDD).toDate();
      object.date = Timestamp.fromDate(dateOnly).toMillis();
  
      object.attendance = teacherIDs;
  
      return object;
    }
  
   //MARK:  button
   const tapOnSave = async () => {
    const hasCheckedTeachers = teacherList.some((teacher) => teacher.isChecked);

    if (!hasCheckedTeachers) {
      toast.error(ToastMessages.teacherAttendance);
      return;
    }
  
    setLoading(true);
    previousAttendance ? updateAttendance() : writeTeachersAttendanceApi();

    setLoading(false);

    previousAttendanceData(moment(calendardate).format(Dateformat.YYYYMMDD));
 
  };
  
  // MARK: fetch API
  async function previousAttendanceData(currentDate) {
    let q = query(
      collection(dbFirestore, TableName.teacherAttendance),
      where("date_value", "==", moment(currentDate).format(Dateformat.YYYYMMDD))
    );

    const querySnapshot = await getDocs(q);
    const attendanceObject = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      id: docs.id,
    }));

    if (attendanceObject.length > 0) {
      const attendanceIDs = attendanceObject[0]["attendance"];
      setPreviousAttendance(attendanceObject[0]);
      fetchTeachersApi(attendanceIDs);
    } else {
      fetchTeachersApi([]);
      setPreviousAttendance(null);
    }
  }

  // teacher API
  async function fetchTeachersApi(teacherIDs) {
    setTeacherList([]);
    let q = query(
      collection(dbFirestore, TableName.teachers),where("status", "==", "active"),
      orderBy("created_at", "desc")
    );
    const querySnapshot = await getDocs(q);

    const teacherList = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      id: docs.id,
    }));

    const newTeachers = [];
    teacherList.forEach((element) => {
      if (teacherIDs.find((data) => data === element.id)) {
        element["isChecked"] = true;
      }
      newTeachers.push(element);
    });
    setTeacherList(newTeachers);
  }

  // MARK: write attendance API
  async function writeTeachersAttendanceApi() {
    const writePayload = payload();
    try {
      await addDoc(collection(dbFirestore, TableName.teacherAttendance), {
        ...writePayload,
      });
      toast.success(ToastMessages.attendance);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    } catch (error) {
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // update attendance api
  async function updateAttendance() {
    const writePayload = payload();
  
    try {
      // Merge old and new attendance
      const updatedAttendance = [
        ...new Set([...previousAttendance.attendance, ...writePayload.attendance]),
      ];
  
      await updateDoc(doc(dbFirestore, TableName.teacherAttendance, previousAttendance.id), {
        attendance: updatedAttendance,
        updated_at: Timestamp.fromDate(new Date()).toMillis(),
      });
  
      toast.success(ToastMessages.attendanceUpdate);
      
      previousAttendanceData(moment(calendardate).format(Dateformat.YYYYMMDD));
    } catch (error) {
      setLoading(false);
      toast.error(error.message);
    } 
  }

  return (
      <div className="col-12">
      <div className="card modules__card mt-5 mb-2">

        <div className="p-fluid">
          <div className="row modules__row">
            <div className="row" style={{ alignItems: "self-end" }}>
              <div className="col-10">
                <h2 className="pt-3">Mark attendance of {today}</h2>
              </div>
              <div className="col-2">
                <Button
                  label="Save" loading= {loading}
                  className="modules__save_button mt-3 float-end"
                  onClick={tapOnSave}
                  style={{ width: "5rem" }}
                ></Button>
              </div>
            </div>
            <ToastContainer autoClose={1000}/>
            <div className="col-12 col-md-6">
              <Calendar
                name="date_value"
                value={calendardate}
                onChange={clickOnDate}
                showIcon
                showButtonBar
                placeholder="dd/mm/yyyy"
                dateFormat="dd/mm/yy"
              />
            </div>
          </div>
        </div>

        <DataTable
          className="mt-5 mb-3"
          value={teacherList}
          emptyMessage="No data found."
        >
          <Column
            field="name"
            header="Name"
            frozen 
            className="font-bold table__column__capital"
          ></Column>
          <Column field="id" header="ID"></Column>
          <Column
            field="actions"
            header="Actions"
            body={(data) => (
              <input
                type="checkbox"
                onChange={clickOnCheckBox(data)}
                checked={data.isChecked}
                className="checkbox_input"
              />
            )}
          ></Column>
        </DataTable>
        </div>
      </div>
  );
}

export default TeachersAttendance;
